import styled from "styled-components";

import LanguageToggleV2 from "./LanguageToggleV2";
import ProvinceSelector from "./ProvinceSelector";

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    font-size: ${({ theme }) => theme.fontSizes.medium};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

const LangAndProvinceSelector = () => (
  <Wrapper data-testid="LangAndProvinceSelectorWrapper">
    <LanguageToggleV2 />
    |
    <ProvinceSelector />
  </Wrapper>
);

export default LangAndProvinceSelector;
